import React, { useState } from 'react';
import { setBrowserCookie } from 'global-utils/cookie-utils';
import cn from 'classnames';
import { sendAgeGateAudit } from 'global-utils/audit';
import styles from './actions.module.scss';
import type { ActionsProps } from './types';

const Actions = ({
  isImageVersion,
  setNoAccess,
  accessAge,
  onCloseAgeGate,
  translations
}: ActionsProps) => {
  const [rememberMe, setRememberMe] = useState(false);
  const onYes = () => {
    const setSessionCookie = !rememberMe;
    setBrowserCookie('cbgAge', accessAge, setSessionCookie);
    onCloseAgeGate();
    sendAgeGateAudit({ rememberMe, olderThan: true });
  };

  const onNo = () => {
    setNoAccess(true);
    sendAgeGateAudit({ rememberMe, olderThan: false });
  };

  const onRememberToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setRememberMe(isChecked);
  };

  const labels = translations?.labels || {};

  return (
    <>
      <div
        className={cn(styles.actions, {
          [styles.imageVersion]: isImageVersion
        })}
      >
        <button
          className={styles.button}
          type="button"
          onClick={onNo}
          data-testid="deny-action"
          name="deny-action"
        >
          {labels.notyet}
        </button>
        <button
          className={styles.button}
          type="button"
          onClick={onYes}
          data-testid="confirm-action"
          name="confirm-action"
        >
          {labels.yes}
        </button>
      </div>
      <div className={styles.remember}>
        <input
          type="checkbox"
          id="checkbox"
          name=""
          value=""
          onChange={onRememberToggle}
        />
        <label htmlFor="checkbox">
          <span>
            {translations.consentMessage} {translations.consentMessageTip}
          </span>
        </label>
      </div>
    </>
  );
};

export default Actions;
